import React, { FC } from 'react';
import { graphql } from 'gatsby';

import Button from 'common/Button';
import GatsbyImage from 'common/GatsbyImage';
import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import useMatchMedia from 'hooks/useMatchMedia';
import { DESKTOP_BREAKPOINT } from 'utils/constants';

import { IHeroProductBannerProps } from './model';

import './HeroProductBanner.scss';

const HeroProductBanner: FC<IHeroProductBannerProps> = ({ bannerData }) => {
  const isDesktop = useMatchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);

  const {
    preamble,
    title,
    description,
    cta: [{ name, url }],
    label,
    image,
    imageAlt,
    icon,
    iconAlt,
    bgImage,
  } = bannerData.properties;

  return (
    <div className="hero-product-banner">
      {isDesktop ? (
        <div className="hero-product-banner__label-container">
          <DangerouslySetInnerHtml html={label} className="hero-product-banner__label" />
        </div>
      ) : null}
      <div className="hero-product-banner__container">
        <div className="hero-product-banner__media">
          {!isDesktop ? (
            <DangerouslySetInnerHtml html={label} className="hero-product-banner__label" />
          ) : null}
          <div className="hero-product-banner__images-container">
            <div className="hero-product-banner__images">
              <GatsbyImage image={image} alt={imageAlt} objectFit="contain" />
              <div className="hero-product-banner__icon">
                <GatsbyImage image={icon} alt={iconAlt} objectFit="contain" />
              </div>
            </div>
          </div>
          {!isDesktop ? (
            <div className="hero-product-banner__decorative">
              <GatsbyImage image={bgImage} objectPosition="right center" />
            </div>
          ) : null}
        </div>
        <div className="hero-product-banner__text">
          <DangerouslySetInnerHtml html={preamble} className="hero-product-banner__preamble" />
          <DangerouslySetInnerHtml html={title} className="hero-product-banner__title" />
          <DangerouslySetInnerHtml
            html={description}
            className="hero-product-banner__description"
          />
          <Button className="hero-product-banner__cta" link={url}>
            {name}
          </Button>
        </div>
      </div>
      {isDesktop ? (
        <div className="hero-product-banner__decorative">
          <GatsbyImage image={bgImage} objectPosition="right center" />
        </div>
      ) : null}
    </div>
  );
};

export const query = graphql`
  fragment FragmentHeroProductBanner on THeroProductBanner {
    properties {
      preamble
      title
      description
      label
      cta {
        name
        url
      }
      image {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 900, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      imageAlt
      icon {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 170, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      iconAlt
      bgImage {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default HeroProductBanner;
